import styled from 'styled-components'

export const WrappedComponentContainer = styled.div`
  position: relative;
`

export const CheckedCirlce = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;

  width: 16px;
  height: 16px;

  border-radius: 50%;

  background-color: var(--Foreground-Primary, #4d4be7);
`

export const AddCompanyButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  box-sizing: border-box;
  margin: 4px 0px;

  cursor: pointer;
`

export const AddCompanyIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;

  svg {
    font-size: 16px;
    fill: var(--Foreground-Primary, #4d4be7);
  }
`

export const AddCompanyLabel = styled.div`
  color: var(--Foreground-Primary, #4d4be7);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const SelectedItemLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;
    color: var(--Foreground-Neutral, #14171f);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  overflow: hidden;
`
